import AssessmentIcon from "@mui/icons-material/Assessment";
import DescriptionIcon from "@mui/icons-material/Description";
import WorkIcon from "@mui/icons-material/Work";
import { useLocation } from "react-router-dom";
import i18n from "../../../i18n";
import MiniDrawer from "../MiniDrawer";
import HandshakeIcon from "@mui/icons-material/Handshake";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";

export const SALES_NAVIGATION_DRAWER_TYPE_ALL = "all";

const salesDrawerActionIcons = [
    {
        label: i18n.t("page.marketing_panel_landing_page.channels"),
        icon: <WorkIcon />,
        link: "/marketing-panel/channels/",
        drawerType: SALES_NAVIGATION_DRAWER_TYPE_ALL,
    },
    {
        label: i18n.t("page.marketing_panel_landing_page.lead_reports"),
        icon: <AssessmentIcon />,
        link: "/marketing-panel/lead-reports/lead_source/",
        drawerType: SALES_NAVIGATION_DRAWER_TYPE_ALL,
    },
    {
        label: i18n.t("headers.contact_channel_report"),
        icon: <LocalPhoneIcon />,
        link: "/marketing-panel/contact_channel_report/",
        drawerType: SALES_NAVIGATION_DRAWER_TYPE_ALL,
    },  
    {
        label: i18n.t("drawer.navigation_drawer.clauses"),
        icon: <HandshakeIcon />,
        // link: `${window._env_.MY_HOME_FRONTEND_URL}investments/`,
        link: "/clauses-admin/",
        drawerType: SALES_NAVIGATION_DRAWER_TYPE_ALL,
    }
    // {
    //     label: i18n.t("page.marketing_panel_landing_page.settlements"),
    //     icon: <DescriptionIcon />,
    //     link: "/marketing-panel/settlements/",
    //     drawerType: SALES_NAVIGATION_DRAWER_TYPE_ALL,
    // }
];

const MaketingPanelNavigationDrawer = ({
    drawerType = SALES_NAVIGATION_DRAWER_TYPE_ALL,
    extraDrawerTypes = [],
    children,
}) => {
    const location = useLocation();

    const getDrawerActionIconsContent = (drawerActionIcons) => {
        return drawerActionIcons
            .filter(
                (drawerActionIcon) =>
                    drawerActionIcon.drawerType === drawerType ||
                    extraDrawerTypes.includes(drawerActionIcon.drawerType),
            )
            .map((drawerActionIcon) => ({
                ...drawerActionIcon,
                callback: () => window.location.replace(drawerActionIcon.link),
                isActive: location.pathname === drawerActionIcon.link,
            }));
    };

    const topDrawerIcons = getDrawerActionIconsContent(salesDrawerActionIcons);

    return (
        // @ts-ignore
        <MiniDrawer
            initialOpen={true}
            topDrawerActionIcons={topDrawerIcons}
            showTopDrawerActionIcons={topDrawerIcons.length > 0}
            middleDrawerActionIcons={[]}
            showMiddleDrawerActionIcons={false}
            bottomDrawerActionIcons={[]}
            showBottomDrawerActionIcons={false}
        >
            {children}
        </MiniDrawer>
    );
};

export default MaketingPanelNavigationDrawer;
